// s99-terms_and_conditions

import selfHtml from './s99-terms_and_conditions.html' with { type: 'text' };;

var root

export async function init(module_root) {

    module_root.innerHTML = selfHtml;

    root = module_root
}